/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorList from 'sites/allas/components/labrador/List';

export const DynamicLabradorList: typeof LabradorList = (props) => {
    return <ErrorBoundary><LabradorList {...props} /></ErrorBoundary>;
}
export type DynamicLabradorListProps = PropsFromComponent<typeof LabradorList>;
